import { instance } from '../apps/apis/instance';
import type { WpProductPayload } from '../models/WpProduct';

export interface BatchUploadRequest {
  products: WpProductPayload[];
  operator: string;
  gpi: string;
  cppi: string;
  wave: string;
}

export class ProductClient {
  private static readonly BASE_PATH = '/woocommerce';

  static async uploadProduct(payload: WpProductPayload): Promise<any> {
    const response = await instance.post(`${this.BASE_PATH}/products`, payload);
    return response.data;
  }

  static async uploadProducts(request: BatchUploadRequest): Promise<any> {
    const response = await instance.post(`${this.BASE_PATH}/products/batch`, request, {
      timeout: 60000, // 60 seconds for batch uploads
    });
    return response.data;
  }
}
